import styled from 'styled-components';

interface MarkdownContentProps {
	isMobile?: boolean;
}

export const MarkdownContent = styled.div<MarkdownContentProps>`
	user-select: text;
	cursor: text;
	display: flex;
	flex-direction: column;
	gap: 2px;
	overflow-wrap: break-word;

	h1 {
		font-size: ${({ isMobile }) => (isMobile ? '24px' : '20px')};
		font-weight: 600;
		margin-top: 8px;
		margin-bottom: 8px;
	}

	h2 {
		font-size: ${({ isMobile }) => (isMobile ? '20px' : '17px')};
		font-weight: 600;
		margin-top: 0px;
		margin-bottom: 6px;
		margin-top: 10px;
	}

	h3 {
		font-size: ${({ isMobile }) => (isMobile ? '18px' : '15px')};
		font-weight: 600;
		margin-top: 0px;
		margin-top: 4px;
		margin-bottom: 6px;
	}

	// bullet points
	ul,
	ol {
		margin: 0;
		padding: 0;
		padding-left: 20px;
		display: flex;
		flex-direction: column;
		gap: 4px;
		margin-bottom: 12px;
	}

	li {
		margin: 0;
		padding: 0;
		line-height: ${({ isMobile }) => (isMobile ? '24px' : '20px')};
	}

	// nested bullet points
	ul ul,
	ol ol {
		padding-bottom: 0;
		margin-bottom: 0px;
	}

	li ul,
	li ol {
		margin: 0;
		margin-top: 5px;
		padding: 0;
		padding-left: 20px;
	}

	p {
		margin: 0;
		padding: 0;
		line-height: ${({ isMobile }) => (isMobile ? '24px' : '20px')};
		margin-bottom: 4px;
	}

	code {
		background-color: ${({ theme }) => theme.gray[200]};
		padding: 1px 4px;
		border-radius: 4px;
		font-size: ${({ isMobile }) => (isMobile ? '13px' : '12px')};
		font-family: 'Monaco', 'Menlo', 'Consolas', monospace;
	}

	a {
		color: ${({ theme }) => theme.gray[1000]};
		font-weight: 500;
		text-decoration: none;
		transition: opacity 0.15s;

		&:hover,
		&:focus-visible {
			opacity: 0.8;
			text-decoration: underline;
		}
	}
`;

export const CodeBlockWrapper = styled.div<{ $isCollapsed: boolean; $hasOverflow: boolean }>`
	position: relative;
	background-color: ${({ theme }) => theme.gray[100]};
	border: 1px solid ${({ theme }) => theme.gray[200]};
	margin: 8px 0;

	pre {
		padding: 12px;
		margin: 0;
		overflow: hidden;
		font-family: 'Monaco', 'Menlo', 'Consolas', monospace;
		font-size: 11px;
		line-height: 1.5;
		background: transparent;
		max-height: ${({ $isCollapsed, $hasOverflow }) =>
			$hasOverflow && $isCollapsed ? 'calc(1.5em * 5)' : 'none'};
		overflow: ${({ $isCollapsed, $hasOverflow }) =>
			$hasOverflow && $isCollapsed ? 'hidden' : 'auto'};
		transition: max-height 0.2s ease;

		code {
			background-color: transparent;
			padding: 0;
			border-radius: 0;
			font-size: inherit;
		}
	}
`;

export const CodeActionsTop = styled.div`
	position: absolute;
	top: 8px;
	right: 8px;
	display: flex;
	gap: 4px;
	z-index: 1;
`;

export const IconButton = styled.button`
	padding: 4px 4px;
	background-color: ${({ theme }) => theme.gray[100]};
	border: 1px solid ${({ theme }) => theme.gray[200]};
	border-radius: 4px;
	color: ${({ theme }) => theme.gray[700]};
	display: flex;
	align-items: center;
	justify-content: center;
	transition: all 0.2s;

	&:hover {
		background-color: ${({ theme }) => theme.gray[200]};
		border-color: ${({ theme }) => theme.gray[400]};
	}
`;

export const ShowMoreLink = styled.button`
	position: absolute;
	bottom: 8px;
	right: 8px;
	padding: 4px 8px;
	background-color: ${({ theme }) => theme.gray[100]};
	border: 1px solid ${({ theme }) => theme.gray[200]};
	border-radius: 4px;
	color: ${({ theme }) => theme.gray[700]};
	font-size: 11px;
	font-weight: 500;
	transition: all 0.2s;

	&:hover {
		background-color: ${({ theme }) => theme.gray[200]};
		border-color: ${({ theme }) => theme.gray[400]};
	}
`;
